import classNames from "classnames";

import { AccessoriesFrontPannelIcon } from "@jti/brand-icons/accessories-front-pannel";
import { DeviceDefaultIcon } from "@jti/brand-icons/device-default";
import { DevicePenIcon } from "@jti/brand-icons/device-pen";
import { DeviceTimeIcon } from "@jti/brand-icons/device-time";
import { DiamondIcon } from "@jti/brand-icons/diamond";
import { HandChooseIcon } from "@jti/brand-icons/hand-choose";
import { HandCoinsIcon } from "@jti/brand-icons/hand-coins";
import { HandDobbleIcon } from "@jti/brand-icons/hand-dobble";
import { StickIcon } from "@jti/brand-icons/stick";

type GetStoreFilterCategoryIconParam = {
  categoryKey: string;
  filterKey: string;
  filtersItemIconContainerClassName?: string;
  colorsClassName?: string;
};

const ProductTypeIconMap: Record<string, JSX.Element> = {
  stick: <StickIcon />,
  ploomdevice: <DeviceDefaultIcon />,
  accessories: <AccessoriesFrontPannelIcon />,
  limitededition: <DiamondIcon />,
};

const ServicesIconMap: Record<string, JSX.Element> = {
  tryadevice: <HandChooseIcon />,
  borrowadevice: <DeviceTimeIcon />,
  tradeyourdevice: <HandDobbleIcon />,
  membergetmember: <HandCoinsIcon />,
  customizeyourdevice: <DevicePenIcon />,
};

const ColorForProductMap: Record<string, string> = {
  amarillo: "--des-color-brand-content-product-yellow2-default",
  amber: "--des-color-brand-content-product-orange2-deepen",
  aquamarine: "--des-color-brand-content-product-blue3-default",
  arcticmint: "--des-color-brand-content-product-green6-default",
  azure: "--des-color-brand-content-product-blue4-default",
  baizeoption: "--des-color-brand-content-product-orange3-default",
  bronze: "--des-color-brand-content-product-brown2-default",
  burgundy: "--des-color-brand-content-product-red2-default",
  cobalt: "--des-color-brand-content-product-blue1-default",
  ecru: "--des-color-brand-content-product-yellow4-default",
  fluo: "--des-color-brand-content-product-green3-default",
  garnet: "--des-color-brand-content-product-pink2-default",
  gleamoption: "--des-color-brand-content-product-orange1-default",
  gold: "--des-color-brand-content-product-yellow1-default",
  green: "--des-color-brand-content-product-green1-default",
  greenfresh: "--des-color-brand-content-product-green5-default",
  greenoption: "--des-color-brand-content-product-green2-default",
  magenta: "--des-color-brand-content-product-purple3-default",
  marine: "--des-color-brand-content-product-blue2-default",
  orange: "--des-color-brand-content-product-orange2-default",
  purple: "--des-color-brand-content-product-purple2-default",
  purpleoption: "--des-color-brand-content-product-purple1-default",
  ruby: "--des-color-brand-content-product-red3-default",
  rubyoption: "--des-color-brand-content-product-red1-default",
  silver: "--des-color-brand-content-product-grey1-default",
  tan: "--des-color-brand-content-product-pink3-default",
  tealgreen: "--des-color-brand-content-product-green1-default",
  teal: "--des-color-brand-content-product-teal1-default",
  velvet: "--des-color-brand-content-product-red4-default",
  wildberry: "--des-color-brand-content-product-purple5-default",
  winterapple: "--des-color-brand-content-product-red5-default",
  yellow: "--des-color-brand-content-product-yellow2-default",
  zestypear: "--des-color-brand-content-product-yellow6-default",
};

export const getStoreFilterCategoryIcon = ({
  categoryKey,
  filterKey,
  filtersItemIconContainerClassName: filtersItemIconContainer,
  colorsClassName,
}: GetStoreFilterCategoryIconParam) => {
  const lowerCaseFilterKey = filterKey?.toLocaleLowerCase().replaceAll(" ", "");
  if (!lowerCaseFilterKey) {
    return undefined;
  }
  if (
    categoryKey === "ProductColors" ||
    categoryKey === "ProductFlavours" ||
    categoryKey === "ProductFlavoursLYO" ||
    categoryKey === "ProductFlavoursVendingMachine" ||
    categoryKey === "ProductFlavoursLYOVendingMachine"
  ) {
    const product = ColorForProductMap[lowerCaseFilterKey];
    return product ? (
      <div
        style={{ background: `var(${product})` }}
        className={classNames(filtersItemIconContainer, colorsClassName)}
      />
    ) : undefined;
  }

  if (categoryKey === "product_types" || categoryKey === "product_types_vending_machine") {
    const productTypeIcon = ProductTypeIconMap[lowerCaseFilterKey];
    return productTypeIcon && <div className={classNames(filtersItemIconContainer)}>{productTypeIcon}</div>;
  }

  if (categoryKey === "services") {
    const servicesIcon = ServicesIconMap[lowerCaseFilterKey];
    return servicesIcon && <div className={classNames(filtersItemIconContainer)}>{servicesIcon}</div>;
  }

  return undefined;
};
